import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import FilterDropdown from '../../../components/FilterDropdown/FilterDropdown';
import Filters from '../Filters/Filters';
import { horsesFilterConfig } from './horseFilterConfig';
const HorseFilters = ({ filter, horseView }) => {
    const { t } = useTranslation();
    const [params, setParams] = useSearchParams();
    const onChange = (filter) => {
        if (filter.color) {
            let colorsArray = [];
            const prevColors = params.get('color') || '';
            if (prevColors !== '') {
                colorsArray = prevColors.split(',');
                colorsArray.push(filter.color);
            }
            else {
                colorsArray.push(filter.color);
            }
            params.set('color', String(colorsArray));
        }
        else {
            const entries = Object.entries(filter);
            entries.forEach(([key, value]) => {
                params.set(key, String(value));
            });
        }
        setParams(params);
    };
    return (_jsx(Filters, Object.assign({ filter: filter }, { children: horsesFilterConfig.map(({ textFilterOptions, colorFilterOptions, label, range, hidden }, idx) => !hidden ? (_jsx(FilterDropdown, { onChange: onChange, title: label, textFilterOptions: textFilterOptions, colorFilterOptions: colorFilterOptions, range: range }, idx)) : null) })));
};
export default HorseFilters;
